import { load_one, load_many } from '../action-helpers'

export default {

    loadAllByCountry: load_many('countries/:countryId/states'),
    loadOne: load_one('states/:id')

}
